<template>
 <div id="app"> 
  <RouterView name="header"></RouterView>
  <RouterView name="default" :dataset="dataset"></RouterView>
  <RouterView name="footer"></RouterView>
  
 </div>
</template>

<script>

import Vue from "vue"
import JsonExcel from "vue-json-excel"
import i18n from '@/mixins/i18n'
import api from '@/api/api.js'
 
Vue.component("downloadExcel", JsonExcel)

export default {
  name: 'App',
  mixins: [i18n, api],  
  props: {
    locale: {
      type: String,
      default: null
    }
  },  
  beforeMount() {
    this.setLocale(this.$route.params.locale)
    window.scrollTo(0, 0)
    this.dataRegentes()
    this.infoRegentes()
  },
  beforeRouteUpdate (to, from, next) {
    this.setLocale(to.params.locale)
    next()
  }
}
</script>

<style lang="scss">
  @import 'node_modules/bootstrap/scss/bootstrap.scss';
  @import 'node_modules/bootstrap-vue/src/index.scss';
  @import './assets/style/main.scss';
</style>
